'use client';

import { useEffect, useState } from 'react';
import { IGeneralSettings } from '../../../models/IGeneralSettings';
import { IPost } from '../../../models/ICategory';
import { twMerge } from 'tailwind-merge';
import HTMLRenderer from '../../components/HTMLRenderer';
import { appConfig } from '../../../config';
import { isBrowser } from '../../../utils/isBrowser';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import styles from '@/styles/post-inner.module.scss';


export default function PostWrapper({post, settings}:{post: IPost; settings: IGeneralSettings}) {





  useEffect(() => {
    const handleCopy = (event: any) => {
      event.preventDefault();
      const selection = document.getSelection();
      if (!selection) return;
      const url = `${appConfig.NEXT_PUBLIC_BASE_URL}/${post.category.uniqueCode}/${post.uniqueCode}`;
      navigator.clipboard.writeText(selection.toString() + `\nاقرأ المزيد على موقع فوشيا: ${url}`);
    }

    if (settings.advancedSettings.showCopyPasteMeta) window.addEventListener("copy", handleCopy);

    const content = post.content || '';
    const scripts: {src: string; onload?: (this: GlobalEventHandlers, ev: Event) => any;}[] = [];

    if (content.includes('instagram-media')) {
      scripts.push({
        src: 'https://www.instagram.com/embed.js',
        onload: () => (window as any).instgrm?.Embeds?.process()
      });
    }
    if (content.includes('fb-post')) {
      scripts.push({src: 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v19.0'});
      // @ts-ignore
      window.fbAsyncInit = function () {
        // @ts-ignore
        window.FB.init({
          xfbml: true,
          version: 'v19.0'
        });
      
        let counter = 0;
        // @ts-ignore
        window.FB.Event.subscribe('xfbml.render', function () {
          counter++;
          if (counter > 1) return;
          adjustFBEmbeds()
        });
      };
    }
    if (content.includes('twitter-tweet')) {
      scripts.push(  {
        src: 'https://platform.twitter.com/widgets.js',
        onload: () =>  (window as any).twttr?.widgets?.load()
      })
    }
    if (content.includes('tiktok-embed')) {
      scripts.push( {
        src: 'https://www.tiktok.com/embed.js',
       },)
    }

    for (const script of scripts) {
      const el = document.createElement("script");
      el.setAttribute("src", script.src);
      el.setAttribute("async", "true");
      if (script.onload) el.onload = script.onload;
      document.body.appendChild(el);
    }

    return () => {
      if (settings.advancedSettings.showCopyPasteMeta) window.removeEventListener('copy', handleCopy);
    }
  }, []);



  function adjustFBEmbeds() {

    if (!isBrowser() || window.innerWidth >= 1024) return;
    const els = document.querySelectorAll<HTMLElement>('.fb-post') || [];
    els.forEach(el => {
      const span = el.childNodes[0];
      const iframe = span.childNodes[0];
      // @ts-ignore
      const {height, width} = span.style;
      const parsedHeight = parseInt(height);
      const parsedWidth = parseInt(width);
      const availableWidth = window.innerWidth;
      const setHeight = `${(availableWidth * (parsedHeight / parsedWidth)).toFixed(1)}px${window.innerWidth < 768 ? '' : ' !important'}`;
      const targets = [el,span,iframe];
      // @ts-ignore
      targets.forEach(x => x.style.height = setHeight)
    }) 
  }
  const [normalizedContent, setNormalizedContent] = useState(() => {
  return (post.content || '')
  .replaceAll(`xmlns:xlink="https://www.w3.org/1999/xlink"`, `xmlns:xlink="http://www.w3.org/1999/xlink"`)
  .replaceAll(`xmlns="https://www.w3.org/2000/svg"`, `xmlns="http://www.w3.org/2000/svg"`)
  .replaceAll(`<script async src=\"https://platform.twitter.com/widgets.js\" charset=\"utf-8\"></script>`, ``)
  // .replaceAll(/src="([^"]*)"/g, 'data-src="$1"')
  })
    // .replaceAll('sandbox', '')
    // .replaceAll('<iframe', '<iframe sandbox="allow-scripts" onload=`javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+"px";}(this));` ')
    // .replaceAll('x.com', 'twitter.com')


    // useEffect(() => {
    //   setTimeout(() => setNormalizedContent(normalizedContent.replaceAll(/data-src="([^"]*)"/g, 'src="$1"')), 1000);
    // },[]);
  

  return (
    <>
    
    {normalizedContent ? <HTMLRenderer content={normalizedContent} className={twMerge(styles['post-inner'], !settings.advancedSettings.allowCopyPaste && 'post-inner-readonly')}/> : null}

    </>
  )

}